import React, { useEffect } from "react";
import "./style.scss";
import { canUseDOM } from "../../utils";
const CheckoutPaymentFrame = ({ iframeUrl, callback }) => {
  const handleMessage = message => {
    switch (message.data.action) {
      case "redirect":
        global.location.href = message.data.payload;
        break;
      case "callback":
        callback && callback(message.data.payload);
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  return (
    <div className="checkout-payment-frame grid">
      <div className="iframe-grid-block">
        <iframe src={iframeUrl} />
      </div>
    </div>
  );
};
export default CheckoutPaymentFrame;
